
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coaches/[uid]",
      function () {
        return require("private-next-pages/coaches/[uid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coaches/[uid]"])
      });
    }
  